import { render, staticRenderFns } from "./GiveFeedbackForm.vue?vue&type=template&id=fb978b66&"
import script from "./GiveFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./GiveFeedbackForm.vue?vue&type=script&lang=js&"
import style0 from "./GiveFeedbackForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports